<div class="simple_menu__wrapper" [ngClass]="{active: active}">
<h1>TEST</h1>
</div>